/**
 * 自动生成 router代码【模块名：标签表】
 * 生成日期：2025/11/06 14:34:21
 * 生成路径: src/router/tag.js
 * 生成人：超级管理员
 * 需要在文件 src/router/router.js 引入当前文件
 * import tag from './tag'
 // 路由详情
 const routes = [
 {
 path: '/',
 component: () => import('@/layouts/BasicLayout'),
 name: 'BasicLayout',
 meta: { title: '首页' },
 redirect: '/myNav',
 children: [
 ...
 tag,//标签表
 ]
 */

export default  {
  path: 'tag/list',
  name: 'tag',
  component: () => import('@/pages/tag/TagList'),
  meta: { title: '标签表管理' },
}
